module.exports = __webpack_public_path__ + "img/icon_submenu9.5c8201af.svg";